import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/Header/Layout/Default.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/Header/MobileMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/Link/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/SectionDownloadApp/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/shop/Gallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/shop/Information.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/shop/Review.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/shop/Service.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/shop/ShopOffers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/shop/ShopSlotDiscounts.tsx");
